export default __webpack_public_path__ + "./image/97024474c0a3553352eeac37b502a800.png";